import React from "react";
import {Form, Select} from "antd";
import {AiExtractorType, AiExtractorWebSearchMode, ExternalWebSearchBackend, SupportedModel} from "../../domain/AiExtractor";

type SupportedModelsByType = Record<string, { models: SupportedModel[] }>;

export function isWebSearchSupportedForModel(type?: AiExtractorType, modelName?: string, supportedModel?: SupportedModel) {
    if (type === AiExtractorType.OLLAMA || type === AiExtractorType.OPENAI_COMPATIBLE_API) {
        return !!modelName && (supportedModel == null || supportedModel.supportsWebSearch === true);
    }

    return supportedModel?.supportsWebSearch === true;
}

export function buildValuesForTypeChange() {
    return {
        model: undefined,
        openAiServiceTier: undefined,
        openAiReasoningEffort: undefined,
        anthropicReasoningEffort: undefined,
        grokReasoningEffort: undefined,
        webSearchMode: AiExtractorWebSearchMode.DISABLED,
        externalWebSearchBackend: ExternalWebSearchBackend.BRAVE,
        aiProviderConnectionId: undefined
    };
}

export function getSupportedModelsForType(allSupportedModels: SupportedModelsByType, type?: AiExtractorType) {
    return type ? (allSupportedModels[type]?.models || []) : [];
}

function getWebSearchModeOptions(type?: AiExtractorType) {
    switch (type) {
        case AiExtractorType.OPENAI_API:
            return [
                {value: AiExtractorWebSearchMode.DISABLED, label: "disabled"},
                {value: AiExtractorWebSearchMode.NATIVE, label: "native OpenAI"},
                {value: AiExtractorWebSearchMode.EXTERNAL, label: "external tools"}
            ];
        case AiExtractorType.OLLAMA:
            return [
                {value: AiExtractorWebSearchMode.DISABLED, label: "disabled"},
                {value: AiExtractorWebSearchMode.EXTERNAL, label: "external tools"}
            ];
        case AiExtractorType.OPENAI_COMPATIBLE_API:
            return [
                {value: AiExtractorWebSearchMode.DISABLED, label: "disabled"},
                {value: AiExtractorWebSearchMode.NATIVE, label: "native"},
                {value: AiExtractorWebSearchMode.EXTERNAL, label: "external tools"}
            ];
        default:
            return [
                {value: AiExtractorWebSearchMode.DISABLED, label: "disabled"},
                {value: AiExtractorWebSearchMode.NATIVE, label: "native"}
            ];
    }
}

type WebSearchFieldsProps = {
    selectedModel?: string;
    selectedWebSearchMode?: AiExtractorWebSearchMode;
    type?: AiExtractorType;
    webSearchSupportedBySelectedModel: boolean;
};

export function AiExtractorWebSearchFields(props: WebSearchFieldsProps) {
    const {selectedModel, selectedWebSearchMode, type, webSearchSupportedBySelectedModel} = props;

    const canShowWebSearchMode = type === AiExtractorType.OLLAMA || type === AiExtractorType.OPENAI_COMPATIBLE_API
        ? !!selectedModel
        : webSearchSupportedBySelectedModel;

    if (!canShowWebSearchMode) {
        return null;
    }

    return (
        <>
            <Form.Item
                name="webSearchMode"
                label="Web search"
                initialValue={AiExtractorWebSearchMode.DISABLED}
            >
                <Select
                    options={getWebSearchModeOptions(type)}
                    placeholder={"Select web search mode"}
                />
            </Form.Item>

            {selectedWebSearchMode === AiExtractorWebSearchMode.EXTERNAL &&
                <Form.Item
                    name="externalWebSearchBackend"
                    label="Web search backend"
                    initialValue={ExternalWebSearchBackend.BRAVE}
                >
                    <Select
                        options={[
                            {value: ExternalWebSearchBackend.BRAVE, label: "Brave"},
                            {value: ExternalWebSearchBackend.OLLAMA, label: "Ollama cloud"}
                        ]}
                        placeholder={"Select web search backend"}
                    />
                </Form.Item>
            }
        </>
    );
}
